import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profile-setup-password',
  templateUrl: './profile-setup-password.component.html',
  styleUrls: ['./profile-setup-password.component.scss']
})
export class ProfileSetupPasswordComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
